import React, { useContext } from 'react';
import {
  Box,
  Skeleton,
  Heading,
  Divider,
  Image,
  ButtonGroup,
  Button,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useEventsQuery } from '../../../../generated/graphqlModels';
import { AuthContext } from '../../../../context/AuthProvider';
import { trackAction } from '../../../../helpers/trackAction';
import { useTranslation } from 'react-i18next';

const Events = () => {
  const { data, loading } = useEventsQuery();
  const user = useContext(AuthContext);
  const { t } = useTranslation();

  const openUrl = (url: string) => {
    window.open(url);
  };

  if (!user) {
    return null;
  }

  if (loading) {
    return (
      <Stack>
        <Skeleton height="60px" />
        <Skeleton height="20px" />
        <Skeleton height="60px" />
        <Skeleton height="20px" />
      </Stack>
    );
  }
  const currentDate = new Date();
  const currentDatePlus10min = new Date(currentDate.getTime() + 10 * 60000);

  const filterEvents = data?.events
    ? data.events.filter((event) => {
        const endDate = new Date(event.endDatetime);
        if (!user.namespaces.includes(event.namespace)) {
          return false;
        }

        const isOld = currentDate >= endDate;
        if (isOld) {
          return false;
        }
        return true;
      })
    : [];

  return filterEvents.length ? (
    <VStack
      backgroundColor="#202e811c"
      padding="10px"
      borderRadius="8px"
      textAlign="center"
    >
      {filterEvents.map((event, key) => {
        const startDate = new Date(event.startDatetime);
        const isLive = true; // currentDatePlus10min >= startDate;

        return (
          <Box key={key} maxWidth={'400px'}>
            <Image src={event.image.url} alt={event.title} borderRadius="lg" />
            <Stack mt="6" spacing="3">
              <Heading size="md">{event.title}</Heading>
              <Text>{event.description}</Text>
              <Text color="blue.600" fontSize="2xl">
                {startDate.toLocaleDateString()}{' '}
                {startDate.toLocaleTimeString()}
              </Text>
            </Stack>
            <Divider />
            <ButtonGroup spacing="2" marginTop={4}>
              <Button
                variant="solid"
                colorScheme={'var(--chakra-colors-blue-600);'}
                disabled={!isLive}
                onClick={() => {
                  openUrl(event.link);
                  trackAction({
                    action_type: 'button_click',
                    data: {
                      text: 'Watch now',
                      url: window.location.pathname,
                      context: 'Watching event',
                    },
                  });
                }}
              >
                {t('events.watchNow')}
              </Button>
            </ButtonGroup>
          </Box>
        );
      })}
    </VStack>
  ) : null;
};

export default Events;
